import React, { FC, useCallback } from 'react';
import styled, { css } from 'styled-components';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import { cardStyles, mediaQuery, Color } from '../Theme';
import { OmnibarButton } from '../omnibar/OmnibarButton';
import { useRouter } from 'next/router';
import { FormattedMessage } from 'react-intl';
import MagnifyIcon from 'mdi-react/MagnifyIcon';

const Container = styled.div`
  ${cardStyles}
  display: flex;
  margin: 0;
  height: 66px;
  background-color: ${Color.white};
  border-radius: 0;

  ${mediaQuery.mobileFirst.medium(css`
    display: none;
  `)}
`;

export interface MobileBarProps {
  showBack?: boolean;
}

export const MobileBar: FC<MobileBarProps> = ({ showBack = false }) => {
  const { back, push } = useRouter();

  const handleSearchClick = useCallback(() => {
    if (showBack) return back();
    return push('/search');
  }, [showBack]);

  return (
    <Container>
      <OmnibarButton icon={showBack ? <ArrowLeftIcon /> : <MagnifyIcon />} iconRight={null} onClick={handleSearchClick}>
        {showBack ? (
          <FormattedMessage id="search.backButton" defaultMessage="Takaisin hakuun" />
        ) : (
          <FormattedMessage id="search.goToSearchButton" defaultMessage="Avaa haku" />
        )}
      </OmnibarButton>
    </Container>
  );
};
